export const getParentNodes = target => {
    let temp = target;
    const targetParents = [];
    while (temp) {
        targetParents.push(temp);
        temp = temp.parentNode;
    }
    return targetParents;
};